import { render, staticRenderFns } from "./blockImageText.vue?vue&type=template&id=7ba70b9e&scoped=true&"
import script from "./blockImageText.vue?vue&type=script&lang=js&"
export * from "./blockImageText.vue?vue&type=script&lang=js&"
import style0 from "./blockImageText.vue?vue&type=style&index=0&id=7ba70b9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba70b9e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VRow,VTextarea})
